import type { IntegrationStatusResponse } from "shared-core/types/integrations";
import { type IntegrationStatusEnum } from "shared-core/types/integrations";
import type { MetaBusinessAccount } from "shared-core/types/meta";

export const IntegrationStoreInjectKey = Symbol("integration-store");

export interface IntegrationStoreActions {
  fetchIntegrationStatuses(): Promise<void>;

  /**
   * Disconnect an integration
   * @param {string} integrationId - The ID of the integration to disconnect
   * @returns {Promise<boolean>} Whether the disconnection was successful
   */
  disconnectIntegration(integrationId: string): Promise<boolean>;

  /**
   * Enable MFA for Facebook Business Manager
   * @returns {Promise<Object>} The response data
   */
  enableFacebookMfa(): Promise<object>;

  /**
   * Connect to Facebook using OAuth popup
   */
  connectToFacebook(): void;

  connectToGoogleWorkspace(): void;

  connectToMicrosoft365(): void;

  getOrGenerateApiKey(integrationId: string): Promise<string>;

  generateApiKey(integrationId: string): Promise<string>;

  downloadWordPressPlugin(): void;

  /**
   * Update the status of an integration
   * @param {string} integrationId - The integration ID
   * @param {IntegrationStatusEnum} status - The new status
   */
  updateIntegrationStatus(
    integrationId: string,
    status: IntegrationStatusEnum,
  ): void;

  getIntegrations(): IntegrationStatusMap;
  fetchMetaBusinessAccounts(): Promise<void>;
}

export interface IntegrationStatusStore extends IntegrationStatusResponse {
  name: string;
  logo: string;
  description: string;
}

export type IntegrationStatusMap = Record<string, IntegrationStatusStore>;

export interface IntegrationStoreState {
  integrations: IntegrationStatusMap;
  isLoading: boolean;
  metaBusinessAccounts: MetaBusinessAccount[];
}
